module.exports = __webpack_public_path__ + "img/dynImg4.47deb741.png";